import { Dispatch } from 'redux';
import { api } from "../config/api";
import { GetState } from "../config/store";
import { 
    postTransactionConfirmationRequest,
    postTransactionConfirmationSuccess,
    postTransactionConfirmationFailure,
    cleanTransaction as cleanTransactionReducer,
    rejectInspectionRequest,
    rejectInspectionSuccess,
    rejectInspectionFailure,
    cleanRejectInspection as cleanRejectInspectionReducer
} from '../reducers/transaction';
import { TransactionPropsBuy, TransactionPropsSell } from "../interfaces/app";
import { axiosClient } from '../config/axios';

export const postTransactionConfirmation = (transaction: TransactionPropsBuy | TransactionPropsSell) => (dispatch: Dispatch) => _postTransactionConfirmation(transaction, dispatch);
const _postTransactionConfirmation = async (transaction: TransactionPropsBuy | TransactionPropsSell, dispatch: Dispatch) => {
    try {
        dispatch({type: postTransactionConfirmationRequest});

        const body = JSON.stringify(transaction);

        await axiosClient.post(`${api.transactions}/inspection-schedules`, body);

        dispatch({type: postTransactionConfirmationSuccess})
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        if(errorResponse?.code) return dispatch({ type: postTransactionConfirmationFailure, payload: errorResponse.code });
        dispatch({type: postTransactionConfirmationFailure, payload: "Ha ocurrido un error"});

    }
}
export const postRejectInspection = (transaction: TransactionPropsBuy | TransactionPropsSell) => (dispatch: Dispatch) => _postRejectInspection(transaction, dispatch);
const _postRejectInspection = async (transaction: TransactionPropsBuy | TransactionPropsSell, dispatch: Dispatch) => {
    try {
        dispatch({type: rejectInspectionRequest});

        const body = JSON.stringify(transaction);

        await axiosClient.post(`${api.transactions}/inspection-schedules`, body);

        dispatch({type: rejectInspectionSuccess})
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        if(errorResponse?.code) return dispatch({ type: rejectInspectionFailure, payload: errorResponse.code });
        dispatch({type: rejectInspectionFailure, payload: "Ha ocurrido un error"});

    }
}

export const cleanTransaction = () => (dispatch: Dispatch) => _cleanTransaction(dispatch);
const _cleanTransaction = (dispatch: Dispatch) => dispatch({type: cleanTransactionReducer})

export const cleanRejectInspection = () => (dispatch: Dispatch) => _cleanRejectInspection(dispatch);
const _cleanRejectInspection = (dispatch: Dispatch) => dispatch({type: cleanRejectInspectionReducer})